// import {
//     Box, Button, Container, Grid, Paper, Popover, Snackbar, Table,
//     TableBody, TableContainer, TableHead, TablePagination, Typography
// } from "@mui/material";
// import React, { useEffect, useState, useRef } from "react";
// import styles from '../../../styles.module.css';
// import { useDispatch, useSelector } from "react-redux";
// import {
//     ActionMsg, AddButton, Breadcrumb, CustomePopover, DeleteDialog, ExcelDownload,
//     HandleSort, SearchInput, StyledTableCell, StyledTableRow, useMessageHandler
// } from "../../reusableComponent/Reusables";

// import ReactToPrint from "react-to-print";
// import { editDeleteProductionEntry, getProductionEntryList } from "../../../actions/actions";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
// import maintenance from "../../../services/maintenance";
// import HeaderSection from "../../reusableComponent/HeaderSection";
// import CustomPagination from "../../reusableComponent/CustomPagination";

// // Print Wrapper
// const ComponentToPrintWrapper = ({ quotationPrint }) => {
//     const ref = useRef();
//     return (
//         <div style={{ display: "flex" }}>
//             <ReactToPrint
//                 trigger={() => (
//                     <span style={{ display: 'flex', justifyContent: 'center' }}>
//                         <PrintOutlinedIcon />
//                         <span style={{ marginLeft: '22px' }}>Print Record</span>
//                     </span>
//                 )}
//                 content={() => ref.current}
//             />
//             <div style={{ display: 'none' }}></div>
//         </div>
//     );
// };

// const MaintenanceList = () => {
//     const dispatch = useDispatch();
//     const [rows, setRows] = useState([]);
//     const [searchKey, setSearchKey] = useState('');
//     const [sortBy, setSortBy] = useState(null);
//     const [isDelete, setIsDelete] = useState(false);
//     const [deleteInfo, setDeleteInfo] = useState(null);
//     const [successMessage, setSuccessMessage] = useState(null);
//     const totalCount = useSelector(state => state.maint_id?.total_count || 0);
//     const defaultRowsPerPage = useSelector(state => state.maint_id?.rows_per_page || 15);
//     // const rows = useSelector(state => state.maint_id.cylinder_inward)
//     const fields = ['entry_no', 'cylinder_no', 'hydro_test_date', 'inspection_date', 'leakage_from_value', 'leakage_from_cyl_neck_thread', 'corrosion_bottom_ring', 'damaged_valve', 'damaged_valve', 'painting', 'burn_mask', 'tag_not_readable', 'corrosion_pitting', 'remarks'];
//     const labels = ['Entry Date', 'Cylinder Number', 'Hydro Test Due', 'Inspection Due', 'Valve Leakage By', '	Neck Thread Leakage', 'Fusible Plug Leakage', 'Bottom Ring Corrosion', 'Cylinder Dent', 'Damaged', 'Painting', 'Burn Mask', 'Tag Not Readable	', 'Corrosion or Pitting', 'Remarks'];
//     const [total_count, setTotalCount] = useState(null)
//     useEffect(() => {
//         setTotalCount(rows[0]?.totalCount);
//     }, [rows]);
//     const [controller, setController] = useState({
//         page: 0,
//         rowsPerPage: defaultRowsPerPage,
//     });

//     useEffect(() => {
//         setController(prev => ({
//             ...prev,
//             rowsPerPage: defaultRowsPerPage,
//             page: 0,
//         }));
//     }, [defaultRowsPerPage]);

//     const fetchData = async () => {
//         try {
//             const params = {
//                 page: controller.page,
//                 size: controller.rowsPerPage,
//                 searchKey: searchKey,
//             };
//             const response = await maintenance.getmaintenanceList(params);
//             setRows(response);
//         } catch (error) {
            
//         }
//     };

//     const handleSearch = async (e) => {
//         const searchValue = e.target.value;
//         setSearchKey(searchValue);
//         const params = {
//             page: controller.page,
//             size: searchValue === '' ? controller.rowsPerPage : totalCount,
//             searchKey: searchValue,
//         };
//         try {
//             await fetchData(params);
//         } catch (error) {
//             console.error('Error in handleSearch:', error);
//         }
//     };

//     useEffect(() => {
//         fetchData();
//     }, [controller.page, controller.rowsPerPage]);

//     const handleChangePage = (event, newPage) => {
//         setController(prev => ({ ...prev, page: newPage }));
//     };

//     const handleChangeRowsPerPage = (event) => {
//         setController({ page: 0, rowsPerPage: parseInt(event.target.value, 10) });
//     };

//     const deleteRecord = async (id) => {
//         try {
//             await maintenance.editDeletemaintenance({
//                 maint_id: id,
//                 changedUpdatedValue: "delete"
//             });
//             setIsDelete(false);
//             fetchData();
//             setSuccessMessage("Record deleted successfully");
//         } catch (error) {
//             setSuccessMessage("Error deleting record");
//         }
//     };

//     const handleDelete = (row) => {
//         setDeleteInfo(row);
//         setIsDelete(true);
//     };

//     const handleClose = () => {
//         setIsDelete(false);
//         setDeleteInfo(null);
//     };

//     // const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData, null, setSuccessMessage, respMsgState);

//     // useEffect(() => {
//     //     if (respMsgState) setSuccessMessage(respMsgState);
//     // }, [respMsgState]);

//     // Sort rows by entry_date descending
//     const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
//     // Calculate pagination info
//     const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
//     const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
//     const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
//     const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


//     console.log('Pagination Info:', { startRecord, endRecord, totalCount, effectiveTotalCount, paginationInfo });

//     const dateConversion = (date) => {
//         if (!date) return "";
//         const today = new Date(date);
//         const dd = String(today.getDate()).padStart(2, "0");
//         const mm = String(today.getMonth() + 1).padStart(2, "0");
//         const yyyy = today.getFullYear();
//         return `${dd}/${mm}/${yyyy}`;
//     };



//     return (
//         <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
//             <Box className={`${styles.body}`}>
//                 <Breadcrumb routeSegments={[{ name: "Maintenance List" },]} />


//                 <HeaderSection
//                     title="MAINTENANCE LIST"
//                     addNewPath="/transactions/add-maintenance"
//                     searchKey={searchKey}
//                     handleSearch={handleSearch}
//                     sortedRows={sortedRows}
//                     fields={fields}
//                     labels={labels}
//                     filename="Maintenance List"
//                     paginationInfo={paginationInfo}
//                     controller={controller}
//                     handleChangePage={handleChangePage}
                    
                
//                 // openscanner={true}
//                 />


//                 <Paper sx={{ width: '100%', }}>
//                     <TableContainer component={Paper} className={styles.list_tbl_container}>
//                         <Table size="small" stickyHeader>
//                             <TableHead>
//                                 <StyledTableRow>
//                                     <StyledTableCell align="left" sx={{ minWidth: '100px !important' }} className={`${styles.table_head}`}>Entry Date</StyledTableCell>
//                                     <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.table_head}`}>Cylinder Number</StyledTableCell>


//                                     <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.table_head}`}>Valve</StyledTableCell>
//                                     <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.table_head}`}> Cylinder Neck Thread</StyledTableCell>
//                                     <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.table_head}`}>Fusible Plug </StyledTableCell>

//                                     <StyledTableCell align="left" sx={{ minWidth: '70px !important' }} className={`${styles.table_head}`}>Painting</StyledTableCell>
//                                     <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.table_head}`}>Cylinder Tag </StyledTableCell>
//                                                                         <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.table_head}`}> Test Result</StyledTableCell>
//                                     <StyledTableCell align="left" sx={{ minWidth: '70px !important' }} className={`${styles.table_head}`}>Remarks</StyledTableCell>
//                                     { <StyledTableCell align="center" sx={{ minWidth: '70px !important' }} className={`${styles.table_head}`}>Action</StyledTableCell> }

//                                 </StyledTableRow>
//                             </TableHead>
//                             <TableBody sx={{ backgroundColor: '#fff' }}>
//                                 {Array.isArray(rows) && rows.map((row, index) => (
//                                     <StyledTableRow key={row.maint_id || index}>

//                                         <StyledTableCell align="left" sx={{ minWidth: '100px !important' }} className={`${styles.list_table_body}`}>{dateConversion(row.entry_date)}</StyledTableCell>
//                                         <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.list_table_body}`}>{row.cylinder_no}</StyledTableCell>
                                      
                                     
//                                         <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.list_table_body}`}>{row.leakage_from_valve}</StyledTableCell>
//                                         <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.list_table_body}`}>{row.leakage_from_cyl_neck_thread}</StyledTableCell>
//                                         <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.list_table_body}`}>{row.leakage_from_fusible_plug}</StyledTableCell>




//                                         <StyledTableCell align="left" sx={{ minWidth: '70px !important' }} className={`${styles.list_table_body}`}>{row.painting}</StyledTableCell>

//                                         <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.list_table_body}`}>{row.tag_not_readable}</StyledTableCell>
//                                           <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.list_table_body}`}>{row.result}</StyledTableCell>

//                                         <StyledTableCell align="left" sx={{ minWidth: '70px !important' }} className={`${styles.list_table_body}`}>{row.remarks}</StyledTableCell>
//                                         <StyledTableCell align="center">
//                                             <CustomePopover
//                                                 row={row}
//                                                 handleDelete={false}
//                                                 linkTo="/transactions/add-maintenance"
//                                                 showEdit={false}
//                                                 handlePrint={false}
//                                                 handleCancel={false}
//                                             />
//                                         </StyledTableCell>
//                                     </StyledTableRow>
//                                 ))}
//                             </TableBody>
//                         </Table>
//                     </TableContainer>

//                    <CustomPagination
//   page={controller.page}
//   rowsPerPage={controller.rowsPerPage}
//   totalCount={total_count || 0}
//   onPageChange={(newPage) => handleChangePage(null, newPage)}
// />
//                 </Paper>


//                 <DeleteDialog
//                     open={isDelete}
//                     handleClose={handleClose}
//                     deleteInfo={deleteInfo}
//                     deleteRecord={deleteRecord}
//                     deleteID={deleteInfo?.maint_id || null}
//                     displayName={deleteInfo?.maint_id || ''}
//                 />

//                 <ReusableSnackbar
//                     open={!!successMessage}
//                     onClose={(event, reason) => {
//                         if (reason !== 'clickaway') setSuccessMessage("");
//                     }}
//                     message={successMessage}
//                     autoHideDuration={2000}
//                     vertical="top"
//                     horizontal="right"
//                 />
//             </Box>
//         </Box>
//     );
// };


import {
    Box, Button, Container, Grid, Paper, Popover, Snackbar, Table,
    TableBody, TableContainer, TableHead, TablePagination, Typography,
    Dialog, DialogContent, IconButton
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import styles from '../../../styles.module.css';
import { useDispatch, useSelector } from "react-redux";
import {
    ActionMsg, AddButton, Breadcrumb, CustomePopover, DeleteDialog, ExcelDownload,
    HandleSort, SearchInput, StyledTableCell, StyledTableRow, useMessageHandler
} from "../../reusableComponent/Reusables";

import ReactToPrint from "react-to-print";
import { editDeleteProductionEntry, getProductionEntryList } from "../../../actions/actions";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import CloseIcon from '@mui/icons-material/Close';
import maintenance from "../../../services/maintenance";
import HeaderSection from "../../reusableComponent/HeaderSection";
import CustomPagination from "../../reusableComponent/CustomPagination";

// Print Wrapper
const ComponentToPrintWrapper = ({ quotationPrint }) => {
    const ref = useRef();
    return (
        <div style={{ display: "flex" }}>
            <ReactToPrint
                trigger={() => (
                    <span style={{ display: 'flex', justifyContent: 'center' }}>
                        <PrintOutlinedIcon />
                        <span style={{ marginLeft: '22px' }}>Print Record</span>
                    </span>
                )}
                content={() => ref.current}
            />
            <div style={{ display: 'none' }}></div>
        </div>
    );
};

const MaintenanceList = () => {
    const dispatch = useDispatch();
    const [rows, setRows] = useState([]);
    const [searchKey, setSearchKey] = useState('');
    const [sortBy, setSortBy] = useState(null);
    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);

    // Dialog state
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const totalCount = useSelector(state => state.maint_id?.total_count || 0);
    const defaultRowsPerPage = useSelector(state => state.maint_id?.rows_per_page || 15);

    const fields = ['entry_no', 'cylinder_no', 'hydro_test_date', 'inspection_date', 'leakage_from_value', 'leakage_from_cyl_neck_thread', 'corrosion_bottom_ring', 'damaged_valve', 'damaged_valve', 'painting', 'burn_mask', 'tag_not_readable', 'corrosion_pitting', 'remarks'];
    const labels = ['Entry No', 'Entry Date', 'Cylinder Number', 'Hydro Test Due', 'Inspection Due', 'Valve Leakage By', 'Neck Thread Leakage', 'Fusible Plug Leakage', 'Bottom Ring Corrosion', 'Cylinder Dent', 'Damaged', 'Painting', 'Burn Mask', 'Tag Not Readable', 'Corrosion or Pitting', 'Remarks'];

    const [total_count, setTotalCount] = useState(null);

    useEffect(() => {
        setTotalCount(rows[0]?.totalCount);
    }, [rows]);

    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: defaultRowsPerPage,
    });

    useEffect(() => {
        setController(prev => ({
            ...prev,
            rowsPerPage: defaultRowsPerPage,
            page: 0,
        }));
    }, [defaultRowsPerPage]);

    const fetchData = async () => {
        try {
            const params = {
                page: controller.page,
                size: controller.rowsPerPage,
                searchKey: searchKey,
            };
            const response = await maintenance.getmaintenanceList(params);
            setRows(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleSearch = async (e) => {
        const searchValue = e.target.value;
        setSearchKey(searchValue);
        const params = {
            page: controller.page,
            size: searchValue === '' ? controller.rowsPerPage : totalCount,
            searchKey: searchValue,
        };
        try {
            await fetchData(params);
        } catch (error) {
            console.error('Error in handleSearch:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [controller.page, controller.rowsPerPage]);

    const handleChangePage = (event, newPage) => {
        setController(prev => ({ ...prev, page: newPage }));
    };

    const handleChangeRowsPerPage = (event) => {
        setController({ page: 0, rowsPerPage: parseInt(event.target.value, 10) });
    };

    const deleteRecord = async (id) => {
        try {
            await maintenance.editDeletemaintenance({
                maint_id: id,
                changedUpdatedValue: "delete"
            });
            setIsDelete(false);
            fetchData();
            setSuccessMessage("Record deleted successfully");
        } catch (error) {
            setSuccessMessage("Error deleting record");
        }
    };

    const handleDelete = (row) => {
        setDeleteInfo(row);
        setIsDelete(true);
    };

    const handleClose = () => {
        setIsDelete(false);
        setDeleteInfo(null);
    };

    // Dialog handlers
    const handleOpenDialog = (row) => {
         console.log("ROW DATA:", row); 
        setSelectedRow(row);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setSelectedRow(null);
    };

    // Sort rows by entry_date descending
    const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));

    // Pagination info
    const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
    const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
    const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
    const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;

    const dateConversion = (date) => {
        if (!date) return "";
        const today = new Date(date);
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const yyyy = today.getFullYear();
        return `${dd}/${mm}/${yyyy}`;
    };

    // Dialog detail fields
    const detailFields = [
        { label: "Entry No", value: selectedRow?.entry_no },
        { label: "Entry Date", value: dateConversion(selectedRow?.entry_date) },
        { label: "Cylinder No", value: selectedRow?.cylinder_no },
        { label: "Test Result", value: selectedRow?.result },
        { label: "Hydro Test Date", value: dateConversion(selectedRow?.hydro_test_date) },
        { label: "Inspection Date", value: dateConversion(selectedRow?.inspection_date) },
        { label: "Leakage - Valve", value: selectedRow?.leakage_from_valve },
        { label: "Leakage - Neck Thread", value: selectedRow?.leakage_from_cyl_neck_thread },
        { label: "Leakage - Fusible Plug", value: selectedRow?.leakage_from_fusible_plug },
        { label: "Corrosion Bottom Ring", value: selectedRow?.corrosion_bottom_ring },
        { label: "Dent In Cylinder", value: selectedRow?.dent_in_cylinder },
        { label: "Damaged Valve", value: selectedRow?.damaged_valve },
        { label: "Painting", value: selectedRow?.painting },
        { label: "Burn Mark", value: selectedRow?.burn_mark },
        { label: "Tag Not Readable", value: selectedRow?.tag_not_readable },
        { label: "Corrosion Pitting", value: selectedRow?.corrosion_pitting },
        { label: "Cylinder Cap", value: selectedRow?.cylinder_cap },
        { label: "Tag No", value: selectedRow?.tag_no },
        { label: "Owner", value: selectedRow?.owner },
        { label: "Remarks", value: selectedRow?.remarks },
    ];

    return (
        <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
            <Box className={`${styles.body}`}>
                <Breadcrumb routeSegments={[{ name: "Maintenance List" }]} />

                <HeaderSection
                    title="MAINTENANCE LIST"
                    addNewPath="/transactions/add-maintenance"
                    searchKey={searchKey}
                    handleSearch={handleSearch}
                    sortedRows={sortedRows}
                    fields={fields}
                    labels={labels}
                    filename="Maintenance List"
                    paginationInfo={paginationInfo}
                    controller={controller}
                    handleChangePage={handleChangePage}
                />

                <Paper sx={{ width: '100%' }}>
                    <TableContainer component={Paper} className={styles.list_tbl_container}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.table_head}`}>Entry No</StyledTableCell>
                                    <StyledTableCell align="left" sx={{ minWidth: '100px !important' }} className={`${styles.table_head}`}>Entry Date</StyledTableCell>
                                    <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.table_head}`}>Cylinder Number</StyledTableCell>
                                    <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.table_head}`}>Valve</StyledTableCell>
                                    <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.table_head}`}>Cylinder Neck Thread</StyledTableCell>
                                    <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.table_head}`}>Fusible Plug</StyledTableCell>
                                    <StyledTableCell align="left" sx={{ minWidth: '70px !important' }} className={`${styles.table_head}`}>Painting</StyledTableCell>
                                    <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.table_head}`}>Cylinder Tag</StyledTableCell>
                                    <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.table_head}`}>Test Result</StyledTableCell>
                                    <StyledTableCell align="left" sx={{ minWidth: '70px !important' }} className={`${styles.table_head}`}>Remarks</StyledTableCell>
                                    <StyledTableCell align="center" sx={{ minWidth: '70px !important' }} className={`${styles.table_head}`}>Action</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody sx={{ backgroundColor: '#fff' }}>
                                {Array.isArray(rows) && rows.map((row, index) => (
                                    <StyledTableRow key={row.maint_id || index}>
                                        {/* Entry No — clickable */}
                                        <StyledTableCell
                                            align="left"
                                            sx={{ minWidth: '120px !important', cursor: 'pointer' }}
                                            className={`${styles.list_table_body}`}
                                        >
                                            <Typography
                                                sx={{
                                                    fontSize: '12px',
                                                    fontWeight: 'bold',
                                                    cursor: 'pointer',
                                                    color: '#1976d2',
                                                    textDecoration: 'underline',
                                                }}
                                                onClick={() => handleOpenDialog(row)}
                                            >
                                                {row.entry_no || 'N/A'}
                                            </Typography>
                                        </StyledTableCell>

                                        <StyledTableCell align="left" sx={{ minWidth: '100px !important' }} className={`${styles.list_table_body}`}>{dateConversion(row.entry_date)}</StyledTableCell>
                                        <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.list_table_body}`}>{row.cylinder_no}</StyledTableCell>
                                        <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.list_table_body}`}>{row.leakage_from_valve}</StyledTableCell>
                                        <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.list_table_body}`}>{row.leakage_from_cyl_neck_thread}</StyledTableCell>
                                        <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.list_table_body}`}>{row.leakage_from_fusible_plug}</StyledTableCell>
                                        <StyledTableCell align="left" sx={{ minWidth: '70px !important' }} className={`${styles.list_table_body}`}>{row.painting}</StyledTableCell>
                                        <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.list_table_body}`}>{row.tag_not_readable}</StyledTableCell>
                                        <StyledTableCell align="left" sx={{ minWidth: '120px !important' }} className={`${styles.list_table_body}`}>{row.result}</StyledTableCell>
                                        <StyledTableCell align="left" sx={{ minWidth: '70px !important' }} className={`${styles.list_table_body}`}>{row.remarks}</StyledTableCell>
                                        <StyledTableCell align="center">
                                            <CustomePopover
                                                row={row}
                                                handleDelete={false}
                                                linkTo="/transactions/add-maintenance"
                                                showEdit={false}
                                                handlePrint={false}
                                                handleCancel={false}
                                            />
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <CustomPagination
                        page={controller.page}
                        rowsPerPage={controller.rowsPerPage}
                        totalCount={total_count || 0}
                        onPageChange={(newPage) => handleChangePage(null, newPage)}
                    />
                </Paper>

                {/* ── Maintenance Details Dialog ── */}
                <Dialog
                    open={openDialog}
                    onClose={handleCloseDialog}
                    maxWidth={false}
                    sx={{
                        "& .MuiDialog-paper": {
                            margin: "auto",
                            width: "85vw",
                            maxHeight: "85vh",
                            boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
                            overflow: "hidden",
                            fontFamily: "'Inter', Arial, sans-serif",
                        },
                    }}
                >
                    {/* Header */}
                    <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#fff", letterSpacing: "0.5px", fontFamily: "'Inter', Arial, sans-serif" }}>
                            MAINTENANCE DETAILS
                        </Typography>
                        <IconButton onClick={handleCloseDialog} sx={{ color: "#fff", p: 0.5 }}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Box>

                    <DialogContent sx={{ padding: "20px 24px", background: "#F4F7FB", overflowY: "auto" }}>
                        <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", overflow: "hidden", mb: 2.5 }}>
                            {/* Card Header */}
                            <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
                                <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "0.4px" }}>
                                    📋 Maintenance Information
                                </Typography>
                            </Box>

                            {/* Detail Fields Grid */}
                            <Grid container>
                                {detailFields.map(({ label, value }) => (
                                    <Grid
                                        item xs={12} sm={6} md={4} key={label}
                                        sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}
                                    >
                                        <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                                            {label}
                                        </Typography>
                                        <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                                            {value || "N/A"}
                                        </Typography>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </DialogContent>

                    {/* Footer */}
                    <Box sx={{ padding: "12px 24px", background: "#F8FAFC", borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "flex-end" }}>
                        <Button
                            onClick={handleCloseDialog}
                            sx={{
                                background: "#E53E3E",
                                color: "#fff",
                                fontSize: "13px",
                                fontWeight: 600,
                                textTransform: "none",
                                padding: "7px 20px",
                                borderRadius: "8px",
                                fontFamily: "'Inter', Arial, sans-serif",
                                "&:hover": { background: "#971f16" },
                            }}
                        >
                            Close
                        </Button>
                    </Box>
                </Dialog>

                <DeleteDialog
                    open={isDelete}
                    handleClose={handleClose}
                    deleteInfo={deleteInfo}
                    deleteRecord={deleteRecord}
                    deleteID={deleteInfo?.maint_id || null}
                    displayName={deleteInfo?.maint_id || ''}
                />

                <ReusableSnackbar
                    open={!!successMessage}
                    onClose={(event, reason) => {
                        if (reason !== 'clickaway') setSuccessMessage("");
                    }}
                    message={successMessage}
                    autoHideDuration={2000}
                    vertical="top"
                    horizontal="right"
                />
            </Box>
        </Box>
    );
};

export default MaintenanceList;
